import { ChangeDetectionStrategy, Component, inject, input, output, signal, viewChild, WritableSignal } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MediaWatcherService, NavigationService } from '@iot-platform/core';
import { IotToolbarEvent, ToolbarSize } from '@iot-platform/models/common';
import { ResizeHandleComponent } from '../resize-handle';

import { ToolbarBreadCrumbConfiguration, ToolbarV2Module } from '../toolbar-v2';
import { IotToolbarDefaultButton, IotToolbarMenuButton } from '../toolbar-v2/toolbar-button/configuration-files';

@Component({
  selector: 'iot-platform-ui-overview-shell',
  imports: [ToolbarV2Module, FlexLayoutModule, MatSidenavModule, MatIcon, ResizeHandleComponent],
  templateUrl: './overview-shell.component.html',
  styleUrl: './overview-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewShellComponent {
  buttonList = input<(IotToolbarDefaultButton | IotToolbarMenuButton)[]>([]);
  pageName = input<string>();
  name = input<string>();
  breadCrumbConfiguration = input<ToolbarBreadCrumbConfiguration>();
  sidenavOpened = input<boolean>(false);
  dispatchToolbarEvent = output<IotToolbarEvent>();
  sidePanel = viewChild<MatSidenav>('sidePanel');
  sideNavContentWidth: WritableSignal<string> = signal('');
  drawerWidth: WritableSignal<string> = signal('');
  protected readonly ToolbarSize = ToolbarSize;
  private readonly navigationService: NavigationService = inject(NavigationService);
  private readonly mediaWatcherService = inject(MediaWatcherService);
  readonly isXSmallScreen = this.mediaWatcherService.isXSmallScreen;

  onReturnButtonClicked(): void {
    this.navigationService.navigateToPreviousOriginPage();
  }

  onBackdropClick(): void {
    this.dispatchToolbarEvent.emit({ type: 'backdropClicked' });
  }

  onToolbarEvent(event: IotToolbarEvent): void {
    this.dispatchToolbarEvent.emit(event);
  }
}
